import { createAction, props } from '@ngrx/store';
import {
  MFAOutcome,
  OneTimeRedemptionPointsTransfer,
} from '@rd/core/mfa/types';
import { HttpError } from '@rd/types/http-error.type';
import { PointsTransaction } from '@rd/types/points-transaction.type';
import { PointsTransferFormData } from '../../types';

export const SubmitPointsTransferForm = createAction(
  '[PointsTransfer] Submit Checkout Form Data',
  props<{
    loyaltyProgramId: string;
    formData: PointsTransferFormData;
  }>(),
);

export const TransferPoints = createAction(
  '[PointsTransfer] Transfer Points',
  props<{
    loyaltyProgramId: string;
    formData: PointsTransferFormData;
  }>(),
);

export const TransferPointsSuccess = createAction(
  '[PointsTransfer] Transfer Points Success',
  props<PointsTransaction>(),
);

export const TransferPointsFail = createAction(
  '[PointsTransfer] Transfer Points Fail',
  props<HttpError>(),
);

export const HydratePointsTransferRedemption = createAction(
  '[PointsTransfer] Hydrate Points Transfer MFA State',
  props<{
    hydrationData: OneTimeRedemptionPointsTransfer;
    outcome: MFAOutcome;
  }>(),
);
